module.exports = __webpack_public_path__ + "img/IMG012.52e0a4b8.jpg";